import { useMemo } from "react";

import type { MediaOfferImage } from "@/features/chat/shared/components/media-offer-card/MediaOfferCard";

const MAX_IMAGES = 5;

interface UseMediaOfferImagesParams {
  images?: MediaOfferImage[];
  teaser?: MediaOfferImage;
}

export const useMediaOfferImages = ({
  images,
  teaser
}: UseMediaOfferImagesParams) => {
  const sortedImages = useMemo(() => {
    if (!images) return [];
    const sorted = [...images].sort(
      (first, second) => (first.position || 0) - (second.position || 0)
    );
    return sorted.slice(0, MAX_IMAGES);
  }, [images]);

  const mainImage = teaser || sortedImages[0];

  const thumbnailImages = useMemo(() => {
    if (teaser) {
      return sortedImages.slice(0, MAX_IMAGES);
    }
    return sortedImages.slice(1);
  }, [teaser, sortedImages]);

  return {
    mainImage,
    thumbnailImages
  };
};
